var map = {
	"./Picture1.png": 45783,
	"./Picture2.png": 80794,
	"./Picture3.png": 16800,
	"./Picture4.png": 51604,
	"./bigtitle.png": 52748,
	"./bigtitle2.png": 91005,
	"./bloc1.png": 52947,
	"./bloc2.png": 1242,
	"./bloc3.png": 82642,
	"./bloc4.png": 38236,
	"./bloc5.png": 49267,
	"./home.png": 12402,
	"./hyper.png": 68455,
	"./logo.png": 74427,
	"./rd1.png": 59694,
	"./rd2.png": 46320,
	"./rd3.png": 53475,
	"./rd4.png": 1746,
	"./red1.png": 74501,
	"./red2.png": 68168,
	"./red3.png": 27281,
	"./red4.png": 29217,
	"./redmi-note-15.png": 72728,
	"./xiaomi-15-ultra.png": 69799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;